// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"c4b98a89","488":"3f2de327","684":"392491ff","728":"8bbdc931","979":"a3882472"}[chunkId] + ".chunk.js";
};